import React from 'react';
import style from './card.module.scss';
import mainStyle from '../../pages/main-page/main-page.module.scss';
import pdfImage from '../../assets/pdf.png';
import mainLogo from '../../../src/assets/logo.png';

const renderScoreBar = (score, maxScore) => {
  const percentage = (score / maxScore) * 100;
  return (
    <div className={style.scoreBarContainer}>
      <div className={style.scoreBarBackground}></div>
      <div
        className={style.scoreBarFill}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

const Card = ({
  heading,
  children,
  className,
  pdfUrl,
  score,
  maxScore,
  desc,
}) => {
  const handleDownloadPdf = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    } else {
      alert('No PDF available to download.');
    }
  };

  const renderHeading = () => {
    if (typeof heading === 'string') {
      return <h3 className={style.cardHeading}>{heading}</h3>;
    }
    return heading;
  };

  return (
    <div className={`${className || ''} ${style.card1}`}>
      {renderHeading()}
      {/* {score && maxScore && (
        <div
          className={`${style.cardChild}  ${pdfUrl ? style.cardChildPdf : ''}`}
        >
          {renderScoreBar(score, maxScore)}
        </div>
      )} */}
      {score && maxScore && (
        <div className={style.biohyCard}>
          <div className={style.biohyContentLeft}>
            <div className={style.biohyScore}>
              <div className={style.scoreValue}>{score}</div>
              <div className={style.otherHalf}>
                <img src={mainLogo} alt="BIOHY" />
                <div
                  className={style.scoreValue}
                  style={{
                    fontSize: '18px',
                    color: '#00000',
                    fontStyle: 'italic',
                  }}
                >
                  Punkte
                </div>
              </div>
            </div>
          </div>
          <div className={style.biohyContent}>
            <div className={style.biohyDescription}>
              <p>{desc}</p>
            </div>
          </div>
        </div>
      )}

      <div
        className={`${style.cardChild}  ${pdfUrl ? style.cardChildPdf : ''}`}
      >
        {pdfUrl ? (
          <>
            <div className={style.iframe}>
              <iframe
                src={`${pdfUrl}`}
                frameBorder="0"
                title="PDF"
                className={style.iframe}
              />
            </div>
            <div className={style.pdf_icon} onClick={handleDownloadPdf}>
              <img src={pdfImage} alt="pdfIcon" />
            </div>
          </>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default Card;
